// import IFieldProps from 'bz-core-controls/controls/form/field/field/IFieldProps';
// import React, { useEffect, useState } from 'react';
// import { faCalendarAlt } from '@fortawesome/pro-light-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import classNames from 'classnames';
// import moment from 'moment';
// import cx from 'classnames';

// interface IProps extends IFieldProps {
//   id?: string;
//   label?: string;
//   labelClass?: string;
//   className?: string;
//   errorText?: string;
//   value?: string;
//   submitted?: boolean;
//   placeholder?: string;
//   required?: boolean;
//   onChange?: (value: any) => void;
// }

// const FieldDatePicker = (props: IProps) => {
//   const {
//     id,
//     label,
//     labelClass,
//     className,
//     value,
//     errorText,
//     submitted,
//     onChange,
//     placeholder,
//     required,
//   } = props;
//   const [date, setDate] = useState<string | null>(null);
//   const [isFocus, setIsFocus] = useState(false);
//   const [errorArray, setErrorArray] = useState<string[]>([]);

//   useEffect(() => {
//     errorText && errorText !== '' && setErrorArray(errorText.split(','));
//   }, [errorText]);

//   useEffect(() => {
//     !value && setDate(null);
//     value && setDate(moment(value).format("DD/MM/YYYY"));
//   }, [value])

//   const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//     const value = event.target.value;
//     value && setDate(moment(value).format("DD/MM/YYYY"));
//     !value && setDate(null);
// 		onChange && onChange(value ? new Date(value).toISOString() : "");
// 	}

//   const handleInputFocus = () => {
//     setIsFocus(true);
//   };

//   const handleInputBlur = () => {
//     setIsFocus(false);
//   };

//   return (
//     <div className={cx('field-container', { 'mb-4': !(!!props.errorText && props.submitted) })}>
//       <label className={cx('click-label', labelClass)}>
//         <span>
//           {label}
//           {required && <span className="text-rose-600 text-normal pl-px">*</span>}
//         </span>
//       </label>
//       <div
//         className={classNames(
//           'relative click-input mb-0 py-0 px-3 flex justify-between items-center cursor-pointer',
//           className,
//           {
//             'border-blue-600': isFocus,
//           }
//         )}>
//         <input
//           id={id}
//           type="date"
//           value={moment(date).format("YYYY-DD-MM")}
//           onFocus={handleInputFocus}
//           onBlur={handleInputBlur}
//           onChange={handleInputChange}
//           className="absolute top-0 left-0 w-full h-full opacity-0"
//         />
//         <div>{date || <span className="text-gray-500">{placeholder}</span>}</div>
//         <div className="py-2">
//           <FontAwesomeIcon icon={faCalendarAlt} className="fa-lg fa-fw" />
//         </div>
//       </div>
//       {!!errorText && submitted && (
//         <div className="pb-2 font-medium text-rose-600">
//           <p>{errorArray.length && errorArray[errorArray.length - 1]}</p>
//         </div>
//       )}
//     </div>
//   );
// };
import FieldDatePicker from '../field-date-picker-react-aria';

export default FieldDatePicker;
